import { render, staticRenderFns } from "./PrintDemo.vue?vue&type=template&id=847b9ef0&scoped=true"
import script from "./PrintDemo.vue?vue&type=script&lang=js"
export * from "./PrintDemo.vue?vue&type=script&lang=js"
import style0 from "./PrintDemo.vue?vue&type=style&index=0&id=847b9ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847b9ef0",
  null
  
)

export default component.exports